// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Chamados_DetalheResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Chamados_DetalheResponse — GET /chamados/detalhe, e também a resposta de
 * abrir / responder / mudar-status.
 *
 * As quatro rotas devolvem a MESMA forma de propósito: as três de escrita
 * mudam um chamado e a tela quer redesenhá-lo inteiro a partir do estado
 * fresco do banco. Uma resposta magra ("ok: true") obrigaria a tela a adivinhar
 * o novo estado ou a fazer um segundo GET — e adivinhar é como uma tela passa
 * a mostrar coisa que o banco não tem.
 *
 * `transicoes_possiveis` é DERIVADO do status atual pelo backend. Sem ele a
 * tela teria de reimplementar a máquina de estados para saber quais botões
 * habilitar — a segunda cópia que ChamadoStatus existe para impedir.
 */
import type { Chamados_ChamadoRow } from './Chamados_ChamadoRow'
import type { Chamados_MensagemRow } from './Chamados_MensagemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Chamados_DetalheResponseDados {
chamado: Chamados_ChamadoRow
mensagens: Chamados_MensagemRow[]
transicoes_possiveis: string[]
sou_suporte: boolean
pedidos_de_agente: string[]
}

export type Chamados_DetalheResponse = ApiResponse<Chamados_DetalheResponseDados>;

registerResponseContract('Chamados_DetalheResponse', {
  chamado: {
    type: 'object',
    required: true,
    fields: {
      id:                     { type: 'number',  required: true },
      codigo:                 { type: 'string',  required: false },
      franquia_id:            { type: 'number',  required: false },
      franquia_nome:          { type: 'string',  required: false },
      aberto_por_nome:        { type: 'string',  required: false },
      assunto:                { type: 'string',  required: false },
      descricao:              { type: 'string',  required: false },
      status:                 { type: 'string',  required: false },
      prioridade:             { type: 'string',  required: false },
      pagina_uri:             { type: 'string',  required: false },
      os_id:                  { type: 'number',  required: false },
      cliente_id:             { type: 'number',  required: false },
      primeira_resposta_at:   { type: 'string',  required: false },
      resolvido_at:           { type: 'string',  required: false },
      created_at:             { type: 'string',  required: false },
      updated_at:             { type: 'string',  required: false },
      ultima_interacao_em:    { type: 'string',  required: false },
      ultima_interacao_texto: { type: 'string',  required: false },
      agente:                 { type: 'string',  required: false },
      agente_marcado_por:     { type: 'string',  required: false },
      agente_marcado_at:      { type: 'string',  required: false },
    },
  },
  mensagens: {
    type: 'array',
    required: true,
    items: {
      id:              { type: 'number',  required: true },
      chamado_id:      { type: 'number',  required: false },
      corpo:           { type: 'string',  required: false },
      interna:         { type: 'boolean', required: false },
      autor_e_suporte: { type: 'boolean', required: false },
      autor_sou_eu:    { type: 'boolean', required: false },
      autor_nome:      { type: 'string',  required: false },
      created_at:      { type: 'string',  required: false },
      anexos: {
        type: 'array',
        required: false,
        items: {
          id:      { type: 'number',  required: true },
          url:     { type: 'string',  required: false },
          nome:    { type: 'string',  required: false },
          mime:    { type: 'string',  required: false },
          tamanho: { type: 'number',  required: false },
        },
      },
    },
  },
  transicoes_possiveis: { type: 'array',   required: true },
  sou_suporte:          { type: 'boolean', required: true },
  pedidos_de_agente:    { type: 'array',   required: true },
})
